import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import { clBasic, SInput } from "./general"

export default function EVdetalle({ proyecto }) { // funciona git con apple
  let { firebase } = useContext(AppContext);
  let color = ["#5858FA", "#87FF2A", "#FF7A00"];

  const [w, setW] = useState(500)
  const [h, setH] = useState(400)
  const [X0, setX0] = useState(70)
  const [Y0, setY0] = useState(320)
  const [cantSemanas, setCantSemanas] = useState(10)

  useEffect(() => {
    setW(Number(document.getElementById("EVdetalle").offsetWidth))
    setH(Number(document.getElementById("EVdetalle").offsetHeight) - 60)
    setX0(50)
    setY0(Number(document.getElementById("EVdetalle").offsetHeight) - 60 - 80)
  }, [])

  useEffect(() => {
    let c = document.getElementById("EVgrafico").getContext("2d");
    c.clearRect(0, 0, w, h)
    let { EV, AC, PV, semana, min, max } = firebase.datosEV(proyecto, cantSemanas); // ultimas cantSemanas semanas max

    if (EV.length) {
      ejes(c, semana);
      evGrafico(c, EV, semana, min, max, color[0], "EV");
      evGrafico(c, AC, semana, min, max, color[2], "AC");
      evGrafico(c, PV, semana, min, max, color[1], "PV");
    }
  });

  function ejes(c, semana) {
    c.beginPath();
    c.strokeStyle = clBasic;
    c.lineWidth = 1;
    c.moveTo(X0, Y0);
    c.lineTo(X0, (h - Y0) / 2);
    c.stroke();
    c.moveTo(X0, Y0);
    c.lineTo(w - X0, Y0);
    c.stroke();
    c.beginPath();
    c.font = "1.9vh Arial";
    c.fillText("Tiempo en semanas", w / 2 - 30, Y0 + 50);
    c.stroke()
  }

  function evGrafico(c, datos, semana, min, max, color, leyenda) {
    function coordX(x) {
      // el x no es el valor en x sino el indice del array correspondiente al mismo
      return X0 + (x * largo) / semana.length;
    }
    function coordY(y) {
      return Y0 - (alto * (y - min)) / (max - min);
    }

    const largo = w - X0 * 2;
    const alto = Y0 - 80;

    // itero sobre los valores
    datos.forEach((d, ind) => {
      c.beginPath();
      c.arc(coordX(ind), coordY(d), 4, 0, 2 * Math.PI, false);
      c.fillStyle = color;
      c.fill();

      c.beginPath();
      c.moveTo(coordX(ind), coordY(d));
      if (ind !== datos.length - 1) {
        //no es el ultimo
        c.lineTo(coordX(ind + 1), coordY(datos[ind + 1]));
        c.strokeStyle = color;
        c.stroke();
        // etiqueta semana
        if (!(ind % 3)) {
          c.beginPath()
          c.fillStyle = clBasic;
          c.font = "1.7vh Arial";
          c.fillText("s" + (semana.length - ind).toString(), coordX(ind), Y0 + 20);
          c.stroke()
        }
      } else {
        c.font = "1.9vh Arial";
        c.fillText(leyenda, coordX(ind) + 10, coordY(datos[ind]));
        c.beginPath()
        c.fillStyle = clBasic;
        c.font = "1.7vh Arial";
        c.fillText("HOY", coordX(ind), Y0 + 20);
        c.stroke()
      }
    });
    // etiqueta eje Y (maximo valor)
    c.beginPath()
    c.fillStyle = clBasic;
    c.font = "1.7vh Arial";
    c.fillText(max.toString(), 10, coordY(max));
    c.stroke()
  }

  return (
    <div style={Scanvas} id="EVdetalle">
      <div style={StituloFiltro}>
        <div style={Stitulo}>
          Earned Value
        </div>
        <div style={Sfiltro}>
          <div style={{ fontSize: "1.7vh", borderBottom: "1px solid #424242" }}>#semanas:</div>
          <input style={{ ...SInput, width: "60px", fontSize: "1.7vh", textAlign: "center", background: "#e6e6e6" }} type="number" value={cantSemanas} onChange={(e) => setCantSemanas(e.target.value)} />
        </div>
      </div>
      <canvas id="EVgrafico" height={h.toString() + "px"} width={w.toString() + "px"} />
    </div>
  );
}

const Scanvas = {
  width: "100%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
};

const StituloFiltro = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly"
}

const Stitulo = {
  fontSize: "2.6vh",
  fontWeight: 700,
  color: clBasic,
  paddingTop: "15px"
}

const Sfiltro = {
  width: "60px",
}